var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (model.get('logo_file_path')) { 
__p+='\n  <img src="'+
((__t=( model.get('logo_file_path') ))==null?'':__t)+
'" alt="'+
((__t=( model.get('name') ))==null?'':__t)+
'" />\n';
 } else { 
__p+='\n  '+
((__t=( model.get('name') ))==null?'':__t)+
'\n';
 } 
__p+='\n';
}
return __p;
};
